import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  ratingList: [],
  avgRating: 0,
  totalReviews: 0,
  processing: false,
};

const getCourseReviewSummarySlice = createSlice({
  name: "getCourseReviewSummary",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      /* TODO: reducer for success*/
      return { ...state, ...action.payload, processing: false };
    },
    failure() {
      /* TODO: reducer for failure*/
      return initialState;
    },
  },
});

const { name, actions, reducer } = getCourseReviewSummarySlice;
const getCourseReviewSummaryAction = createAction(name);

export {
  getCourseReviewSummaryAction,
  actions as getCourseReviewSummaryActions,
  reducer as getCourseReviewSummaryReducer,
};
